import React from 'react';
import styles from './MediaGrid.module.scss';
import { Container } from 'ui/components/4-habitats/Container/Container';
import { MediaItem, MediaItemProps } from './MediaItem/MediaItem';
import ColorOptions from 'helpers/types';
import classNames from 'classnames';

export interface MediaGridProps {
	items: MediaItemProps[];
	description?: string;
	bgColor?: ColorOptions;
}

export const MediaGrid: React.FC<MediaGridProps> = ({ items, description, bgColor = 'white' }) => (
	<div className={classNames(styles.MediaGrid, styles[`u-color___${bgColor}`])}>
		<Container width="Standard">
			<div
				className={
					items.length === 1
						? styles.MediaGrid_singleMedia
						: items.length === 2
						? styles.MediaGrid_twoMedia
						: items.length === 3
						? styles.MediaGrid_threeMedia
						: styles.MediaGrid_multipleMedia
				}
			>
				{items &&
					items.map((item, index) => {
						const type = items.length;
						let sizes = '';
						if (type === 1) sizes = '(max-width: 1728px) 100vw, 1728px';
						if (type === 2) sizes = '(max-width: 768px) 100vw, (max-width: 1728px) 50vw, 864px';
						if (type === 3 && index + 1 === 3) sizes = '(max-width: 768px) 100vw, (max-width: 1728px) 66vw, 1150px';
						if (type === 3 && index + 1 !== 3) sizes = '(max-width: 768px) 100vw, (max-width: 1728px) 33vw, 575px';
						return <MediaItem key={index} {...item} className={styles.MediaGrid_item} sizes={sizes} />;
					})}
			</div>
			{description && (
				<p className={styles.MediaGrid_description}>
					{description.split('\n').map((line, i) => (
						<React.Fragment key={i}>
							{line}
							{i < description.split('\n').length - 1 && <br />}
						</React.Fragment>
					))}
				</p>
			)}
		</Container>
	</div>
);
